import { useNavigate, NavigateFunction, useLocation } from 'react-router-dom';

export let globalNavigate: NavigateFunction;

export const GlobalHistory = () => {
    globalNavigate = useNavigate();

    return null;
};

export let globalSetQueryParams: (queryParams: string) => void;

export const GlobalSetQueryParams = () => {
    const location = useLocation();
    globalSetQueryParams = (queryParams: string) => {
        globalNavigate(`${location.pathname}?${queryParams}`);
    };
    return null;
};
